import React, { useState } from 'react';
import { usePrevious } from '@gogame/hooks-ts';
import { defaultGetOptionValue, defaultGetOptionLabel } from '../defaults';
import Badge from '@gogame/ui/Badge';

import {
  closestCenter,
  DndContext,
  DragOverlay,
  PointerSensor,
  KeyboardSensor,
  useSensor,
  useSensors,
  UniqueIdentifier,
} from '@dnd-kit/core';
import {
  arrayMove,
  sortableKeyboardCoordinates,
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import List from '@gogame/ui/List';

import { useRowRenderer } from '../useRowRenderer';
import SortableItem from './SortableItem';
import { BaseListItem, Container, ScrollContainer } from '../components';

function SortableList({
  adjustScale = false,
  strategy = verticalListSortingStrategy,
  itemCount = 100,
  handle = true,
  getItemStyles = () => ({}),
  modifiers,
  onReorder,
  ...props
}) {
  const {
    data,
    getOptionValue = defaultGetOptionValue,
    getOptionLabel = defaultGetOptionLabel,
  } = props;
  console.log('props', props);
  const [activeId, setActiveId] = useState(() => null);
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      // Disable smooth scrolling in Cypress automated tests
      scrollBehavior: 'Cypress' in window ? 'auto' : undefined,
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );
  const getIndex = (v) =>
    data.findIndex((item) => {
      const itemV = getOptionValue(item);
      console.log('itemV', itemV, v);
      return itemV === v;
    });
  const activeIndex = activeId != null ? getIndex(activeId) : -1;

  const ids = data.map(getOptionValue);

  const { renderRow, getRowProps } = useRowRenderer({
    ...props,
    isSelected: (row) => selected?.includes(row),
    isChanged: (row) => {
      return previousSelection?.includes(row) && !selected?.includes(row);
    },
    onItemClick: (e, row) => {
      console.log('onItemClick', e, row);
      setSelected((selected) => {
        return selected?.includes(row)
          ? selected.filter((v) => v !== row)
          : [...selected, row];
      });
    },
    getOptionLabel,
    getOptionValue,
  });

  const renderActive = (id) => {
    console.log('getRowProps.activeId', id);
    const row = data?.find((item) => getOptionValue(item) === id);
    const { primaryLabel, icon, secondaryLabel } = getRowProps(row);
    return (
      <SortableItem id={id} elevation={3}>
        <BaseListItem
          primaryLabel={primaryLabel}
          icon={icon}
          secondaryLabel={secondaryLabel}
          secondaryAction={
            selected.length > 1 ? (
              <Badge badgeContent={selected.length} color={'error'} />
            ) : null
          }
        />
        {/*{renderRow(row)}*/}
      </SortableItem>
    );
  };

  const [selected, setSelected] = useState([]);
  const previousSelection = usePrevious(selected);

  return (
    <Container>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragStart={({ active, ...o }, ...a) => {
          console.log('getRowProps.onDragStart', active, o, a);
          setActiveId(active.id);
        }}
        onDragEnd={({ over, ...o }) => {
          if (over) {
            const overIndex = getIndex(over.id);
            if (selected.length > 1) {
              const newOrder = selected.reduce((acc, v) => {
                const activeIndex = acc.indexOf(v);
                const newIndex = overIndex;

                return arrayMove(acc, activeIndex, newIndex);
              }, data);
              onReorder(newOrder);
              setSelected([]);
            } else {
              if (activeIndex !== overIndex) {
                onReorder(arrayMove(data, activeIndex, overIndex));
              }
            }
          }

          setActiveId(null);
        }}
        onDragCancel={() => setActiveId(null)}
        modifiers={modifiers}
      >
        <SortableContext items={ids} strategy={strategy} useDragOverlay={true}>
          <ScrollContainer>
            <List disablePadding={true}>
              {data.map((item) => {
                const id = getOptionValue(item);
                return (
                  <SortableItem
                    id={id}
                    key={id}
                    height={48}
                    disabled={
                      activeId && activeId !== id && selected?.includes(item)
                    }
                  >
                    {renderRow(item)}
                  </SortableItem>
                );
              })}
            </List>
          </ScrollContainer>
        </SortableContext>

        <DragOverlay adjustScale={adjustScale}>
          {activeId != null ? renderActive(activeId) : null}
        </DragOverlay>
      </DndContext>
    </Container>
  );
}

export default SortableList;
